export interface IOption {
  label: string;
  value: string;
}

export interface IOptionIcon {
  label: string;
  value: string;
  icon?: any;
}

export interface IOptionGroup {
  groupLabel: string;
  options: IOption[];
}

export const optionNone = 'None';
